/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NeeDocumentsStatus model module.
 * @module model/NeeDocumentsStatus
 * @version 1.0.0
 */
class NeeDocumentsStatus {
    /**
     * Constructs a new <code>NeeDocumentsStatus</code>.
     * @alias module:model/NeeDocumentsStatus
     */
    constructor() { 
        
        NeeDocumentsStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NeeDocumentsStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NeeDocumentsStatus} obj Optional instance to populate.
     * @return {module:model/NeeDocumentsStatus} The populated <code>NeeDocumentsStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NeeDocumentsStatus();

            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('open_date')) {
                obj['open_date'] = ApiClient.convertToType(data['open_date'], 'String');
            }
            if (data.hasOwnProperty('close_date')) {
                obj['close_date'] = ApiClient.convertToType(data['close_date'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} enabled
 */
NeeDocumentsStatus.prototype['enabled'] = undefined;

/**
 * @member {String} open_date
 */
NeeDocumentsStatus.prototype['open_date'] = undefined;

/**
 * @member {String} close_date
 */
NeeDocumentsStatus.prototype['close_date'] = undefined;






export default NeeDocumentsStatus;

